import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ProductLicenseDto } from "@dashboard/modules/material-management/product-license/model/product-license.dto";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { KlDyModalComponent } from "@dashboard/components/partials/modal/modal.component";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { PrimengLocal } from "@app/modules/shared/constants/primeng-local";

@Component({
  selector: "kl-product-license-form",
  templateUrl: "./product-license-form.component.html",
  styleUrls: ["./product-license-form.component.scss"],
})
export class ProductLicenseFormComponent implements OnInit, OnDestroy {
  @Input() entity: ProductLicenseDto = new ProductLicenseDto();
  @Input() isReadOnly: boolean;
  @Input() mode: string;
  @Input() tabId: string;
  @Input() listTabId: string;
  @Input() modalId: string;
  title = "";
  alertShow: boolean;
  alertType: string;
  alertMessage: string;
  generateCodeSpin: boolean;
  saveForm = false;
  isOpen = true;
  lem_end_date: Date;
  dateFormatString = UtilService.dateFormatString
    .toLowerCase()
    .replace("yy", "");
  locale =
    PrimengLocal[
      localStorage.getItem("currentLanguage")
        ? localStorage.getItem("currentLanguage").toUpperCase()
        : "TR"
    ];

  constructor(
    private apiService: ApiService,
    private utilService: UtilService,
    private translateService: TranslateService,
    private klLoadingService: KlLoadingService,
    public klModal: KlDyModalComponent,
    private toastService: ToastService,
    private explorerService: ExplorerService
  ) {}

  ngOnInit() {
    this.title = this.translateService.instant("product_license") + " - ";
    if (this.entity.lem_end_date)
      this.lem_end_date = new Date(this.entity.lem_end_date);
    this.klLoadingService.hide();
  }

  commitSave() {
    this.saveForm = true;
    this.entity = {
      ...this.entity,
      lem_end_date: this.lem_end_date ? this.lem_end_date.getTime() : null,
    };
    this.apiService.updateData("product-license", this.entity).subscribe(
      () => this.handleResponse(),
      (error) => this.handleError(error)
    );
  }

  handleResponse() {
    this.toastService.toastSuccess();
    if (this.modalId) {
      this.explorerService.closeModal(this);
    }
    if (this.listTabId) {
      this.explorerService.setRefreshEndProsseses(this.listTabId);
    }
  }

  handleError(error) {
    this.saveForm = false;
    this.alertShow = true;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
  }

  ngOnDestroy() {
    this.apiService.unlockData("product-license", this.entity.id).subscribe();
  }
}
